import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { RouterModule } from "@angular/router";

import { PersonSelectorComponent } from "./personselector.component";
import { PersonSelectorFilterComponent } from "./personselector.filter.component";
import { PersonSelectorService } from "./personselector.service";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { RadioButtonModule } from "primeng/radiobutton";
import { TableModule } from "primeng/table";
import { ProgressSpinnerModule } from "primeng/progressspinner";
@NgModule({
	declarations: [PersonSelectorComponent, PersonSelectorFilterComponent],
	imports: [
		RadioButtonModule,
		CommonModule,
		FormsModule,
		AppSharedModule,
		CalendarModule,
		ConfirmDialogModule,
		DialogModule,
		TableModule,
		RouterModule,
		ProgressSpinnerModule,
	],
	exports: [PersonSelectorComponent],
	providers: [PersonSelectorService],
})
export class PersonSelectorModule {}
